module.exports = __webpack_public_path__ + "img/column.0e9e4a93.svg";